import {BaseDomainModel} from "../../infrastructure/models/base-domain-model";

export class EntityGroupDomainModel extends BaseDomainModel {
  entities: Array<BaseDomainModel>;
  groupItem: BaseDomainModel;

  constructor(groupItem: BaseDomainModel, entities: Array<BaseDomainModel>) {
    super(groupItem);

    this.groupItem = groupItem;
    this.entities = entities;
  }
}

